import React, { useEffect, useState } from "react";
import "./App.css";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Header from "./components/header/Header";
import Sidebar from "./components/sidebar/Sidebar";
import Dashboard_main from "./components/dashboard-main/Dashboard_main";
import List_view_dashboard from "./components/dashboard-main/list-view-dashboard/List_view_dashboard";
import Dashboard_view_dashboard from "./components/dashboard-main/dashboard-view-dashboard/Dashboard_view_dashboard";
import Login from "./components/login/Login";
import Cookies from "js-cookie";
import Offcanvas from "react-bootstrap/Offcanvas";

// import Add_New_State from "./components/sidebar-components/states/add-new-state/Add_New_State";
// import All_States from "./components/sidebar-components/states/all-states/All_States";

//////////////////////////////////////////////////////////////Masters//////////////////////////////////////////////////////////////
import Country from "./components/sidebar-components/masters/country/Country";
import State from "./components/sidebar-components/masters/state/Table";
import City from "./components/sidebar-components/masters/city/Table";
import Pincode from "./components/sidebar-components/masters/pincode/Table";
import Vehicle_Type from "./components/sidebar-components/masters/vehicletype/Table";
import Vehicle_Category from "./components/sidebar-components/masters/vehiclecategory/Table";
import Vehicle from "./components/sidebar-components/masters/vehicle/Table";
import EcoFriendly from "./components/sidebar-components/masters/ecofriendly/Table";
import Banner from "./components/sidebar-components/masters/banner/Table";
import Save_Location from "./components/sidebar-components/masters/savelocation/Table";
import Good_Type from "./components/sidebar-components/masters/goodtype/Table";
import Faq from "./components/sidebar-components/masters/faq/Table";
import Coupon from "./components/sidebar-components/masters/coupon/Table";
import CouponHistory from "./components/sidebar-components/masters/couponhistory/Table";
import Recharge from "./components/sidebar-components/recharge-management/recharge/Table";
import UserRecharge from "./components/sidebar-components/recharge-management/user_recharge/Table";
import Gift from "./components/sidebar-components/gift-management/gift/Table";
import UserGift from "./components/sidebar-components/gift-management/user_gift/Table";
import Broadcast from "./components/sidebar-components/broadcast/broadcast/Table";
import Document from "./components/sidebar-components/document/document/Table";

import Booking_Cancel_Reason from "./components/sidebar-components/masters/booking_cancel_reason/Booking_Cancel_Reason";
import Amenity from "./components/sidebar-components/masters/amenity/Table";
import Aboutme from "./components/sidebar-components/masters/aboutme/Table";

//////////////////////////////////////////////////////////////Masters Ends//////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////About Us//////////////////////////////////////////////////////////////

import About_Us from "./components/sidebar-components/about-us/aboutus/Table";
import Key_Feature from "./components/sidebar-components/about-us/keyfeature/Table";
import Why_Choose_Us from "./components/sidebar-components/about-us/whychooseus/Table";

//////////////////////////////////////////////////////////////About Us Ends//////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////Content//////////////////////////////////////////////////////////////

import Term_Condition from "./components/sidebar-components/content/termcondition/Table";
import Privacy_Policy from "./components/sidebar-components/content/privacypolicy/Table";
import Driver_privacy_policy from "./components/sidebar-components/content/driver_privacy_policy/Table";
import CustomerBookingTNC from "./components/sidebar-components/content/customer_booking_tnc/Table";
import CustomerTermsAndCondition from "./components/sidebar-components/content/customer_terms_and_condition/Table";
import ShippingRidePolicy from "./components/sidebar-components/content/shipping_ride_policy/Table";
import CancellationPolicy from "./components/sidebar-components/content/cancellation_policy/Table";
import RefundPolicy from "./components/sidebar-components/content/refund_policy/Table";
import DriverTermsAndCondition from "./components/sidebar-components/content/driver_terms_and_condition/Table";

//////////////////////////////////////////////////////////////Content Ends//////////////////////////////////////////////////////////////

import App_Setup from "./components/sidebar-components/customization/appsetup/Table";
import Cab_App_Setup from "./components/sidebar-components/customization/cabappsetup/Table";
import Transport_App_Setup from "./components/sidebar-components/customization/transportappsetup/Table";

import Contact from "./components/sidebar-components/form/contactus/Table";
import Enquiry from "./components/sidebar-components/form/enquiry/Table";

import Users from "./components/sidebar-components/user-management/user/Table";
import Roles from "./components/sidebar-components/role-management/role/Table";
import RolesEdit from "./components/sidebar-components/role-management/role/Edit";
import Driver from "./components/sidebar-components/customer-management/driver/Table";
import Customer from "./components/sidebar-components/customer-management/customer/Table";

import Driver_Banner from "./components/sidebar-components/masters/driverbanner/Table";

import Training_Video from "./components/sidebar-components/masters/trainingvideos/Table";
import GetAllSOSRequest from "./components/sidebar-components/sos/get_all_sos/Table";

//////////////////////////////////////////////////////////////transport booking////////////////////////////////////////////////////////////////////

import GetAllTransportBooking from "./components/sidebar-components/transport_booking/get_all_booking/Table";
////////////////////////////////////////////////////////////////////transport booking//////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////Cab booking////////////////////////////////////////////////////////////////////

import GetAllCabBooking from "./components/sidebar-components/cab_booking/get_all_booking/Table";
////////////////////////////////////////////////////////////////////Cab booking//////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////Share booking////////////////////////////////////////////////////////////////////

import GetAllShareBooking from "./components/sidebar-components/share_booking/get_all_booking/Table";
////////////////////////////////////////////////////////////////////Share booking//////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////Driver Wallet//////////////////////////////////////////////////////////////

import GetAllWalletWithdrawRequest from "./components/sidebar-components/driver_wallet/all_wallet_withdraw_request/Table";
import GetAllWalletHistory from "./components/sidebar-components/driver_wallet/wallet_history/Table";
import GetAllWalletFundAddRequest from "./components/sidebar-components/driver_wallet/all_fund_add_request/Table";
import GetAllWalletPayments from "./components/sidebar-components/driver_wallet/wallet_payment/Table";

/////////////////////////////////////////////////////////////Driver Wallet Ends//////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////Customer Wallet//////////////////////////////////////////////////////////////

import GetAllCustomerWalletWithdrawRequest from "./components/sidebar-components/customer_wallet/all_wallet_withdraw_request/Table";
import GetAllCustomerWalletHistory from "./components/sidebar-components/customer_wallet/wallet_history/Table";
import GetAllCustomerWalletFundAddRequest from "./components/sidebar-components/customer_wallet/all_fund_add_request/Table";

/////////////////////////////////////////////////////////////Customer Wallet Ends//////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////Heat Map//////////////////////////////////////////////////////////////

import GetAllHeatMapTransport from "./components/sidebar-components/heat_map_transport/Table";

import GetAllHeatMapCab from "./components/sidebar-components/heat_map_cab/Table";

/////////////////////////////////////////////////////////////heat Map Ends//////////////////////////////////////////////////////////////
import { useDispatch, useSelector } from "react-redux";
import { isTokenValid } from "./features/auth/Slice";
import { IDS } from "./utils/IDS";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightLeft } from "@fortawesome/free-solid-svg-icons";

function App({ closeSidebar }) {
  const handleMenuClick = () => {
    // Close the Offcanvas when a menu item is clicked
    if (closeSidebar) {
      closeSidebar();
    }
  };

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const isLoginPage = location.pathname === "/login";
  const Permission = useSelector((state) => state.auth.permissions);
  const isLogin = useSelector((state) => state.auth.isLogin);

  const [urls, setUrls] = useState([]);

  useEffect(() => {
    setUrls([
      {
        path: "/login",
        element: <Login />,
        status: true,
      },
      {
        path: "/",
        element: <Dashboard_main />,
        status: true,
      },
      {
        path: "/dashboard-list-view",
        element: <List_view_dashboard />,
        status: true,
      },
      {
        path: "/dashboard-view",
        element: <Dashboard_view_dashboard />,
        status: true,
      },
      {
        path: "/country-table",
        element: <Country />,
        // status: Permission?.includes(IDS.Permission.Country.List),
        status: true,
      },
      {
        path: "/booking-cancel-reason",
        element: <Booking_Cancel_Reason />,
        // status: Permission?.includes(IDS.Permission.Country.List),
        status: true,
      },
      {
        path: "/amenity",
        element: <Amenity />,
        // status: Permission?.includes(IDS.Permission.Country.List),
        status: true,
      },
      {
        path: "/about-me",
        element: <Aboutme />,
        // status: Permission?.includes(IDS.Permission.Country.List),
        status: true,
      },
      {
        path: "/state-table",
        element: <State />,
        status: Permission?.includes(IDS.Permission.State.List),
      },
      {
        path: "/city-table",
        element: <City />,
        status: Permission?.includes(IDS.Permission.City.List),
      },
      {
        path: "/pincode-table",
        element: <Pincode />,
        status: Permission?.includes(IDS.Permission.Pincode.List),
      },
      {
        path: "/vehicle-type",
        element: <Vehicle_Type />,
        // status: Permission?.includes(IDS.Permission.Vehicle_Type.List),
        status: true,
      },
      {
        path: "/vehicle-category",
        element: <Vehicle_Category />,
        status: Permission?.includes(IDS.Permission.Vehicle_Category.List),
      },
      {
        path: "/vehicle",
        element: <Vehicle />,
        status: Permission?.includes(IDS.Permission.Vehicle_Category.List),
      },
      {
        path: "/ecofriendly",
        element: <EcoFriendly />,
        status: Permission?.includes(IDS.Permission.Vehicle_Category.List),
      },
      {
        path: "/banner",
        element: <Banner />,
        status: Permission?.includes(IDS.Permission.Banner.List),
      },
      {
        path: "/aboutus",
        element: <About_Us />,
        status: Permission?.includes(IDS.Permission.About_Us.List),
      },
      {
        path: "/keyfeature",
        element: <Key_Feature />,
        status: Permission?.includes(IDS.Permission.Key_Feature.List),
      },
      {
        path: "/whychooseus",
        element: <Why_Choose_Us />,
        status: Permission?.includes(IDS.Permission.Why_Choose_Us.List),
      },
      {
        path: "/termconditions",
        element: <Term_Condition />,
        status: Permission?.includes(IDS.Permission.Term_Condition.List),
      },
      {
        path: "/save_location",
        element: <Save_Location />,
        status: Permission?.includes(IDS.Permission.Save_Location.List),
      },
      {
        path: "/good_type",
        element: <Good_Type />,
        status: Permission?.includes(IDS.Permission.Good_Type.List),
      },
      {
        path: "/faq",
        element: <Faq />,
        status: Permission?.includes(IDS.Permission.Faq.List),
      },
      {
        path: "/coupon",
        element: <Coupon />,
        status: Permission?.includes(IDS.Permission.Vehicle_Category.List),
      },
      {
        path: "/coupon-history",
        element: <CouponHistory />,
        status: Permission?.includes(IDS.Permission.Vehicle_Category.List),
      },

      {
        path: "/recharge-table",
        element: <Recharge />,
        status: Permission?.includes(IDS.Permission.Recharge.List),
        status: true,
      },
      {
        path: "/user-recharge-table",
        element: <UserRecharge />,
        status: Permission?.includes(IDS.Permission.Recharge.List),
        status: true,
      },
      {
        path: "/gift-table",
        element: <Gift />,
        status: Permission?.includes(IDS.Permission.Gift.List),
        status: true,
      },
      {
        path: "/user-gift-table",
        element: <UserGift />,
        status: Permission?.includes(IDS.Permission.Gift.List),
        status: true,
      },
      {
        path: "/broadcast-send",
        element: <Broadcast />,
        status: Permission?.includes(IDS.Permission.Faq.List),
      },
      {
        path: "/document-require",
        element: <Document />,
        status: Permission?.includes(IDS.Permission.Faq.List),
      },

      {
        path: "/appsetup",
        element: <App_Setup />,
        status: Permission?.includes(IDS.Permission.App_Setup.List),
      },

      {
        path: "/cabappsetup",
        element: <Cab_App_Setup />,
        status: Permission?.includes(IDS.Permission.App_Setup.List),
      },

      {
        path: "/transportappsetup",
        element: <Transport_App_Setup />,
        status: Permission?.includes(IDS.Permission.App_Setup.List),
      },
      {
        path: "/contactus",
        element: <Contact />,
        status: Permission?.includes(IDS.Permission.Contact.List),
      },
      {
        path: "/enquiry",
        element: <Enquiry />,
        status: Permission?.includes(IDS.Permission.Enquiry.List),
        // status: true,
      },
      {
        path: "/privacypolicy",
        element: <Privacy_Policy />,
        //  status: Permission?.includes(IDS.Permission.Privacy_Policy.List),
        status: true,
      },

      {
        path: "/driverprivacypolicy",
        element: <Driver_privacy_policy />,
        //  status: Permission?.includes(IDS.Permission.Privacy_Policy.List),
        status: true,
      },

      {
        path: "/cutomer-booking-tnc",
        element: <CustomerBookingTNC />,
        status: Permission?.includes(IDS.Permission.Faq.List),
      },

      {
        path: "/customer-terms-and-condition",
        element: <CustomerTermsAndCondition />,
        status: Permission?.includes(IDS.Permission.Faq.List),
      },

      {
        path: "/shippingridepolicy",
        element: <ShippingRidePolicy />,
        status: Permission?.includes(IDS.Permission.Term_Condition.List),
      },

      {
        path: "/cancellationpolicy",
        element: <CancellationPolicy />,
        status: Permission?.includes(IDS.Permission.Term_Condition.List),
      },

      {
        path: "/refundpolicy",
        element: <RefundPolicy />,
        status: Permission?.includes(IDS.Permission.Term_Condition.List),
      },

      {
        path: "/driver-terms-and-condition",
        element: <DriverTermsAndCondition />,
        status: Permission?.includes(IDS.Permission.Faq.List),
      },

      {
        path: "/trainingvideos",
        element: <Training_Video />,
        status: Permission?.includes(IDS.Permission.Training_Video.List),
        // status: true,
      },
      {
        path: "/users",
        element: <Users />,
        status: Permission?.includes(IDS.Permission.Users.List),
        status: true,
      },
      {
        path: "/roles",
        element: <Roles />,
        status: Permission?.includes(IDS.Permission.Roles.List),
        status: true,
      },
      {
        path: "/roles-edit/:id",
        element: <RolesEdit />,
        status: Permission?.includes(IDS.Permission.Roles.Edit),
        status: true,
      },
      {
        path: "/driver",
        element: <Driver />,
        // status: Permission?.includes(IDS.Permission.Driver.List),
        status: true,
      },
      {
        path: "/customer",
        element: <Customer />,
        // status: Permission?.includes(IDS.Permission.Customer.List),
        status: true,
      },
      {
        path: "/driverbanner",
        element: <Driver_Banner />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },

      ///////////////////////////////////////////SOS////////////////////////////////////////////
      {
        path: "/sos-request",
        element: <GetAllSOSRequest />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },

      ///////////////////////////////////////////Transport Booking////////////////////////////////////////////
      {
        path: "/booking",
        element: <GetAllTransportBooking />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },
      ////////////////////////////////////////////////Transport Booking///////////////////////////////////////

      ///////////////////////////////////////////Cab Booking////////////////////////////////////////////
      {
        path: "/cab-booking",
        element: <GetAllCabBooking />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },
      ////////////////////////////////////////////////Cab Booking///////////////////////////////////////

      ///////////////////////////////////////////Cab Booking////////////////////////////////////////////
      {
        path: "/share-booking",
        element: <GetAllShareBooking />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },
      ////////////////////////////////////////////////Cab Booking///////////////////////////////////////

      ///////////////////////////////////////////////////////Driver Wallet ///////////////////////////////////////////////
      {
        path: "/withdraw-request",
        element: <GetAllWalletWithdrawRequest />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },

      {
        path: "/wallet-history",
        element: <GetAllWalletHistory />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },
      {
        path: "/wallet-payments",
        element: <GetAllWalletPayments />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },

      {
        path: "/wallet-fund-add-request",
        element: <GetAllWalletFundAddRequest />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },
      ///////////////////////////////////////////////////////Driver Wallet Ends ///////////////////////////////////////////////

      ///////////////////////////////////////////////////////Customer Wallet ///////////////////////////////////////////////
      {
        path: "/customer-withdraw-request",
        element: <GetAllCustomerWalletWithdrawRequest />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },

      {
        path: "/customer-wallet-history",
        element: <GetAllCustomerWalletHistory />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },

      {
        path: "/customer-wallet-fund-add-request",
        element: <GetAllCustomerWalletFundAddRequest />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },
      ///////////////////////////////////////////////////////Customer Wallet Ends ///////////////////////////////////////////////

      //////////////////////////////////////////////////////////Heat Map////////////////////////////////////////////////////

      {
        path: "/heat-map",
        element: <GetAllHeatMapTransport />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },

      {
        path: "/heat-map-cab",
        element: <GetAllHeatMapCab />,
        // status: Permission?.includes(IDS.Permission.Driver_Banner.List),
        status: true,
      },
      //////////////////////////////////////////////////////////Heat Map Ends////////////////////////////////////////////////////
    ]);
  }, [Permission]);

  const ValidateToken = async () => {
    await dispatch(isTokenValid());
    const token = Cookies.get("pmroad_admin_security");
    if (!isLogin && !token) {
      navigate("/login");
    } else if (isLoginPage) {
      navigate("/");
    }
  };

  useEffect(() => {
    ValidateToken();
  }, [isLogin]);

  // const [isLaptopView, setIsLaptopView] = useState(window.innerWidth > 991);
  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsLaptopView(window.innerWidth > 991);
  //   };
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  // if (!isLaptopView) {
  //   return (
  //     <div style={{ padding: "2rem", textAlign: "center" }}>
  //       <h2>Please open this design in laptop view</h2>
  //     </div>
  //   );
  // }

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      {/* Conditionally render Header based on the current route */}

      {location.pathname !== "/login" && <Header />}

      <section className="dashboard_layout">
        <div className="container-fluid p-0">
          <div className="layout-flex">
            {location.pathname !== "/login" && (
              <div className="sidebar-div">
                <div className="destopviewsidebar">
                  <Sidebar />{" "}
                </div>

                <div className="mobileviewsidebar">
                  <button className="sidebaropnbtn" onClick={handleShow}>
                    <FontAwesomeIcon icon={faRightLeft} />
                  </button>
                  <Offcanvas show={show} onHide={handleClose}>
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title></Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <Sidebar closeSidebar={handleClose} />{" "}
                    </Offcanvas.Body>
                  </Offcanvas>
                </div>
              </div>
            )}

            {!isLogin ? (
              <Login />
            ) : (
              <div className="content-div">
                <Routes>
                  {urls?.map(
                    (url) =>
                      url.status && (
                        <Route path={url.path} element={url.element} />
                      ),
                  )}
                  {/* <Route path="*" element={<PageNotFound />} /> */}
                </Routes>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* <Routes>
        <Route path="/login" element={<Login />} />
      </Routes> */}
    </>
  );
}

export default App;
